import type {
  AppInitAction,
  AppInitActionPayload,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export const APP_INIT = 'APP_INIT';
export function appInit(payload: AppInitActionPayload): AppInitAction {
  return {
    type: APP_INIT,
    payload,
  };
}
